import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import SigningMethodType from '@app/store/contract-progress/SigningMethodType';

interface DocumentsParticipantsLinkInfoResponse {
  documentId: string;
  participantId: string;
  linkKey: string;
  signingMethodType: SigningMethodType;
}

interface NewDocumentsParticipantsLinkInfoResponse {
  documentId: string;
  participantId: string;
  linkKey: string;
  signingMethod: SigningMethodType;
}

const convertToDeprecatedResponse = (
  response: NewDocumentsParticipantsLinkInfoResponse
): DocumentsParticipantsLinkInfoResponse => {
  return {
    documentId: response.documentId,
    participantId: response.participantId,
    linkKey: response.linkKey,
    signingMethodType: response.signingMethod,
  };
};

/**
 * GET 서명 토큰으로 링크 정보 조회
 * 예전에 서명 링크 주소가 /editor/validation/:token 였는데 변경되서
 * 하위 호환을 위해 token 기준으로 링크 정보를 조회합니다.
 * @see: https://modusign.slack.com/archives/C01PP3J0U3H/p1622775710061600
 *
 * @deprecated Endpoint response is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#b24696d73a124ed4a82ddbcf888fb58a
 */
export function getDocumentsParticipantsLinkInfo(token: string): Promise<{
  documentId: string;
  participantId: string;
  linkKey: string;
  signingMethodType: SigningMethodType;
}> {
  return requestApi<NewDocumentsParticipantsLinkInfoResponse>({
    url: withDocument(`/documents/participants/link-info`),
    method: 'GET',
    params: {
      signatureToken: token,
    },
    credentials: false,
  }).then((response) => convertToDeprecatedResponse(response.data));
}
